import { match } from 'ts-pattern';
import { useCustomBreakpoint, useTailwindBreakpoint } from './useTailwindBreakpoint';

// Get row count for main trade page orderbook
export const useOrderbookRowCount = () => {
  const is2xl = useTailwindBreakpoint('2xl');
  // Temporary custom breakpoint halfway between 2xl and 3xl
  const is1640 = useCustomBreakpoint('1640px');
  const is3xl = useTailwindBreakpoint('3xl');
  const is4xl = useTailwindBreakpoint('4xl');
  const is5xl = useTailwindBreakpoint('5xl');
  return match({ is2xl, is1640, is3xl, is4xl, is5xl })
    .with({ is5xl: true }, () => 16)
    .with({ is4xl: true }, () => 14)
    .with({ is3xl: true }, () => 12)
    .with({ is1640: true }, () => 10)
    .otherwise(() => 9);
};
